import { render } from "./UploadMappingList.vue?vue&type=template&id=62d8e798&scoped=true"
import script from "./UploadMappingList.vue?vue&type=script&lang=js"
export * from "./UploadMappingList.vue?vue&type=script&lang=js"

import "./UploadMappingList.vue?vue&type=style&index=0&id=62d8e798&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62d8e798"

export default script